module.exports = __webpack_public_path__ + "img/logo_tiktok_pixel.c690f329.svg";